import { FormikInput } from 'shared/components/FormikInput'
import { Icon } from 'shared/components/Icons'
import {
    DeleteIconContainer,
    IconContainer,
    TariffListItemWrapper,
} from './style'

type Tariff = {
    hours: number
    price: number
}

interface TariffListItemProps {
    tariff: Tariff
    index: number
    remove: <X = any>(index: number) => X | undefined
    isHoursEditable: boolean
    isPricePerHoursEditable: boolean
    isRequired?: boolean
}

export function TariffListItem({
    index,
    remove,
    isHoursEditable,
    isPricePerHoursEditable,
    isRequired
}: TariffListItemProps) {
    function handleDeleteListItem() {
        remove(index)
    }
    return (
        <TariffListItemWrapper>
            <FormikInput
                name={`ad_price_info.tariffs.${index}.hours`}
                label={isRequired ? `Тариф на 1 ч.` : 'Количество часов'}
                type='number'
                className='inputForm'
                $afterIcon={ isHoursEditable ? 'clearInput': null }
                maskConfig={{ mask: Number }}
                disabled={!isHoursEditable}
                required={isRequired}

            />
            <IconContainer>
                <Icon name='switchHorizontal' />
            </IconContainer>
            <FormikInput
                name={`ad_price_info.tariffs.${index}.price`}
                label={isRequired ? `Цена за ${index + 1} ч.` : 'Цена, ₽'}
                type='number'
                className='inputForm'
                $afterIcon='clearInput'
                $beforeIcon='rubleOutline'
                maskConfig={{ mask: Number }}
                disabled={!isPricePerHoursEditable}
                required={isRequired}
            />
            {!isRequired && isHoursEditable && (
                <DeleteIconContainer
                    onClick={handleDeleteListItem}
                    type='button'
                    disabled={!isHoursEditable}
                >
                    <Icon name='delete' />
                </DeleteIconContainer>
            )}
        </TariffListItemWrapper>
    )
}
